// extracted by mini-css-extract-plugin
module.exports = {"c-login-page__form":"LoginPage_c-login-page__form__NuzHF","c-login-page__register-account-container":"LoginPage_c-login-page__register-account-container__f3eJC"};